<script>
export default {
  name: "DidoMillesimeTableRowColumnsFilters",
};
</script>

<script setup>
import { ref, watch } from "vue";
import api from "../../../../api";
import DidoMillesimeInputFilterWrapper from "../../filters/Wrapper.vue";

// define Props
const props = defineProps({
  show: { type: Boolean, required: true },
  apiUrl: { type: String, required: true },
  visibleColumns: { type: Array, required: true },
  availableFiltersInColumns: { type: Array, required: true },
  modelValue: { type: Object, required: true },
});

// define Emits
const emit = defineEmits(["update:model-value"]);

// define reactive data and watcher from props for activeFilters
const activeFilters = ref(props.modelValue);
watch(
  () => props.modelValue,
  () => (activeFilters.value = props.modelValue),
);

// define method for specs of column
const specsOfColumn = (colName) =>
  props.availableFiltersInColumns.find(({ name }) => name === colName);

// define method for available filters in column as list options
const availableFiltersInColumn = (colName) =>
  specsOfColumn(colName).filters.map((filterName) => ({
    label: api.filters[filterName],
    value: filterName,
  }));

// define method for type of columns
const typeOfColumn = (colName) => specsOfColumn(colName).type;

const availableValuesOfColumn = (colName) => {
  // get filters and available values in column specs
  const { filters, availableValues } = specsOfColumn(colName);

  // column without in and nin filter nothing to return
  if (!filters.find((filterName) => ["in", "nin"].includes(filterName)))
    return null;

  // active filter in column is not in or nin nothing to return
  if (!["in", "nin"].includes(activeFilters.value[colName].type)) return null;

  // if available values exist in columns specs and is not empty we return it
  if (availableValues && availableValues.length) return availableValues;

  return null;
};
</script>

<template>
  <QTr v-if="props.show">
    <QTd
      v-for="colName in props.visibleColumns"
      :key="colName"
      class="bg-grey-2 text-secondary"
    >
      <QSelect
        v-model="activeFilters[colName].type"
        dense
        options-dense
        square
        outlined
        :options="availableFiltersInColumn(colName)"
        class="dido-millesime-table-row-columnsfilters-cell-filterselect"
        clearable
        clear-icon="mdi-close"
        emit-value
        map-options
        @update:model-value="[
          (activeFilters[colName].value = ''),
          emit('update:model-value', activeFilters),
        ]"
      />
      <DidoMillesimeInputFilterWrapper
        v-if="activeFilters[colName].type"
        v-model="activeFilters[colName].value"
        :filter="activeFilters[colName].type"
        :available-values="availableValuesOfColumn(colName)"
        :type="typeOfColumn(colName)"
        :api-url="props.apiUrl"
        @update:model-value="[
          (activeFilters[colName].value = $event),
          emit('update:model-value', activeFilters),
        ]"
      />
    </QTd>
  </QTr>
</template>

<style lang="sass" scoped>
.dido-millesime-table-row-columnsfilters-cell-filterselect
  min-width: 150px
</style>
